import Reac, { forwardRef } from "react";
import MaskedInput from "react-text-mask";

const DniInput = forwardRef(function DniInput(props, ref) {
  const { ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(innerRef) => {
        if (!innerRef) return;

        const inputElement = innerRef.inputElement || innerRef;

        if (typeof ref === "function") {
          ref(inputElement);
        } else if (ref) {
          ref.current = inputElement;
        }
      }}
      mask={(rawValue = "") => {
        const value = rawValue.replace(/\s/g, "");

        let mask = [/\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/];

        if (value.length > 7)
          mask = [/\d/, /\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/];

        return mask;
      }}
      placeholderChar={"\u2000"}
    />
  );
});

export default DniInput;
